import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.small.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import AzImg from '~/components/Atoms/AzImg.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'Gallery',
  props: {
    defaultImage: {
      type: String,
      default: ''
    },
    pictures: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    current: {
      type: Number,
      default: 1
    },
    small: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    videosOnCarousel: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var YoutubeThumbnail = function YoutubeThumbnail() {
      return import('~/components/Atoms/YoutubeThumbnail.vue');
    };
    var GalleryStickers = function GalleryStickers() {
      return import('~/components/Atoms/GalleryStickers.vue');
    };
    var YoutubePlayer = function YoutubePlayer() {
      return import('~/components/Molecules/YoutubePlayer.vue');
    };
    var currentSlide = ref(0);
    var carouselRef = ref(null);
    var _useMobileObserver = useMobileObserver(),
      isMobile = _useMobileObserver.isMobile,
      isTablet = _useMobileObserver.isTablet,
      isPortrait = _useMobileObserver.isPortrait;
    var mainAttributes = computed(function () {
      var _props$content;
      return (_props$content = props.content) === null || _props$content === void 0 ? void 0 : _props$content.productMainAttribute;
    });
    var stickerImageNumber = computed(function () {
      var _mainAttributes$value, _mainAttributes$value2;
      return ((_mainAttributes$value = mainAttributes.value) === null || _mainAttributes$value === void 0 ? void 0 : (_mainAttributes$value2 = _mainAttributes$value.fields) === null || _mainAttributes$value2 === void 0 ? void 0 : _mainAttributes$value2.position) - 1;
    });
    var imagesWithVideosGallery = computed(function () {
      var currentImages = _toConsumableArray(props.pictures);
      var sortedVideosOnCarouselByOrder = _toConsumableArray(props.videosOnCarousel).sort(function (a, b) {
        return a.fields.order - b.fields.order;
      });
      sortedVideosOnCarouselByOrder.forEach(function (video) {
        var order = video.fields.order - 1;
        var preparedObj = {
          isVideo: true,
          videoUrl: video.fields.video.fields.youtubeVideoUrl,
          name: video.fields.video.fields.name,
          isYoutubeVideo: !!video.fields.video.fields.youtubeVideoUrl
        };
        var secondPart = currentImages.splice(order, currentImages.length);
        currentImages = [].concat(_toConsumableArray(currentImages), [preparedObj], _toConsumableArray(secondPart));
      });
      var filteredImages = currentImages.filter(function (currImage) {
        return !(currImage !== null && currImage !== void 0 && currImage.isVideo) || currImage.isVideo && currImage.videoUrl;
      });
      if (props.pictures.length === 1 && filteredImages.some(function (item) {
        return item.isVideo;
      })) {
        filteredImages = filteredImages.filter(function (item) {
          return !item.isVideo ? item.url : true;
        });
      }
      return filteredImages;
    });

    /**
     * Slides the carousel to the given index.
     *
     * @param      {number}  index   The index
     */
    function toSlide(index) {
      carouselRef.value.scrollTo(carouselRef.value.clientWidth * index, 0);
      currentSlide.value = index;
    }
    var isScrolling = null;

    /**
     * Called on scroll.
     */
    function onScroll() {
      if (isScrolling) window.clearTimeout(isScrolling);
      isScrolling = setTimeout(updateCurrentSlide, 120);
    }

    /**
     * Updates the current slide value.
     * Called on scroll
     */
    function updateCurrentSlide() {
      var _carouselRef$value, _carouselRef$value$ch, _carouselRef$value2;
      var currentScroll = (_carouselRef$value = carouselRef.value) === null || _carouselRef$value === void 0 ? void 0 : _carouselRef$value.scrollLeft;
      var children = (_carouselRef$value$ch = (_carouselRef$value2 = carouselRef.value) === null || _carouselRef$value2 === void 0 ? void 0 : _carouselRef$value2.children) !== null && _carouselRef$value$ch !== void 0 ? _carouselRef$value$ch : [];
      currentSlide.value = _toConsumableArray(children).findIndex(function (i) {
        return i.offsetLeft >= currentScroll;
      });
    }

    /**
     * Determines if sticker shown.
     *
     * @param      {number}                  index   The index
     * @param      {MixedContentOnCarousel}  item    The item
     * @return     {boolean}                 True if sticker shown, False otherwise.
     */
    function isStickerShown(index, item) {
      return index === stickerImageNumber.value && !item.isVideo;
    }

    /**
     * Gets the image size.
     *
     * @param      {number}             index   The index
     * @param      {PictureOnCarousel}  item    The carousel item
     * @return     {string}             The image size.
     */
    function getImageSize(index, item) {
      var imageHeight = 723;
      var imageWidth = 626;
      if (isMobile.value) {
        imageHeight = 396;
        imageWidth = 428;
      }
      if (isTablet.value && isPortrait.value) {
        imageHeight = 396;
        imageWidth = 810;
      }
      if (isStickerShown(index, item)) imageHeight = 626;
      if (props.small) imageHeight = 441;
      return "".concat(imageWidth, "x").concat(imageHeight);
    }
    var resizeType = computed(function () {
      return isTablet.value && isPortrait.value ? 'c_scale' : 'c_fill';
    });
    return {
      __sfc: true,
      YoutubeThumbnail: YoutubeThumbnail,
      GalleryStickers: GalleryStickers,
      YoutubePlayer: YoutubePlayer,
      props: props,
      currentSlide: currentSlide,
      carouselRef: carouselRef,
      isMobile: isMobile,
      isTablet: isTablet,
      isPortrait: isPortrait,
      mainAttributes: mainAttributes,
      stickerImageNumber: stickerImageNumber,
      imagesWithVideosGallery: imagesWithVideosGallery,
      toSlide: toSlide,
      isScrolling: isScrolling,
      onScroll: onScroll,
      updateCurrentSlide: updateCurrentSlide,
      isStickerShown: isStickerShown,
      getImageSize: getImageSize,
      resizeType: resizeType,
      AzImg: AzImg
    };
  }
});